import { Button } from '@bpinternal/ui-kit-next'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { Plus, TrafficCone } from 'lucide-react'
import { ComponentProps } from 'react'
import { Boundary, Page } from '~/components'
import { isLegacyBilling } from '~/features/billing/utils/billingVersion'
import { useCurrentRouteId } from '~/hooks'
import { NavbarActionsProvider, useNavbarActions } from '~/providers/NavbarACtionsContext'
import { useSuspenseQuery } from '~/services'

function NavbarActionsConsumer() {
  const { navbarActions } = useNavbarActions()
  return <>{navbarActions}</>
}

export const Route = createFileRoute('/workspaces/$workspaceId/usage')({
  component: Component,
})

function Component() {
  const { workspaceId } = Route.useParams()
  const currentRouteId = useCurrentRouteId() ?? ''
  const { data: workspace } = useSuspenseQuery('workspaces_/$workspaceId_', { workspaceId })

  if (!isLegacyBilling(workspace)) {
    return (
      <Page title="Usage">
        <div className="flex h-full flex-col items-center justify-center gap-4 py-16 text-muted-foreground">
          <TrafficCone className="size-10" />
          <div className="text-center">
            <h3 className="text-lg font-medium text-foreground">Under Construction</h3>
            <p className="mt-1 text-sm">Usage tracking for this workspace is coming soon.</p>
          </div>
        </div>
      </Page>
    )
  }

  const items: ComponentProps<typeof Page>['navbarItems'] = [
    {
      children: 'Workspace',
      to: '/workspaces/$workspaceId/usage/monthly-summary',
    },
    {
      children: 'Bot',
      to: '/workspaces/$workspaceId/usage/ai-spend',
    },
  ]

  const itemsWithActiveState = items.map((i) => ({
    ...i,
    active: currentRouteId.includes(i?.to ?? 'not-a-path'),
  }))

  return (
    <NavbarActionsProvider>
      <Page
        title="Usage"
        actions={
          <Link to={'/workspaces/$workspaceId/billing'} params={{ workspaceId }}>
            <Button>
              <Plus />
              Increase Limits
            </Button>
          </Link>
        }
        navbarItems={itemsWithActiveState}
        navbarActions={<NavbarActionsConsumer />}
      >
        <Boundary>
          {/* TODO: Add Skeleton loading screen */}
          <Outlet />
        </Boundary>
      </Page>
    </NavbarActionsProvider>
  )
}
